import type React from 'react'

export type InlineListItemProps = React.PropsWithChildren

export function InlineListItem({ children }: InlineListItemProps): React.ReactElement {
  return <div data-testid="inline-list-item">{children}</div>
}
